export const ACTIVITY_THUMB_SIZE = {
  height: 84,
  width: 146,
}
